module.exports = __webpack_public_path__ + "static/media/BikeSharing-retro7.5d139097.pdf";